// components/pipeline/PipelineHeader.jsx
// Pipeline Dashboard Header using StandardHeader

import React from 'react';
import { Settings, Clock } from 'lucide-react';
import { StandardHeader } from '../../common/StandardHeader';

export const Header = ({ 
  loading,
  syncing,
  lastUpdated,
  nextScheduledRun,
  loadingNextRun,
  onSyncAll,
  onOpenSettings,
}) => {
  // Format last updated from pipelines data
  const getLastUpdatedTime = () => {
    if (!lastUpdated || !Array.isArray(lastUpdated)) return null;
    
    const validDates = lastUpdated
      .filter(p => p.lastSynced)
      .map(p => new Date(p.lastSynced).getTime());
    
    if (validDates.length === 0) return null;
    
    return new Date(Math.max(...validDates)).toISOString();
  };

  // Format next scheduled run display text
  const getNextRunDisplay = () => {
    if (loadingNextRun) return 'Loading...';
    if (!nextScheduledRun) return 'Loading...';
    if (nextScheduledRun.auto_sync_enabled !== true) return 'Not Enabled';
    if (!nextScheduledRun.next_run_time) return 'Not scheduled';
    return nextScheduledRun.next_run_time;
  };

  const isSyncing = Object.keys(syncing).length > 0;

  // Custom controls for Pipeline (Settings button only - Sync All is handled by StandardHeader's refresh button)
  const customControls = (
    <button
      onClick={onOpenSettings}
      className="flex items-center justify-center px-4 py-2 bg-white text-blue-600 rounded-md hover:bg-blue-50 transition-colors font-medium text-sm"
      title="Data Sync Settings"
    >
      <Settings className="h-4 w-4" />
    </button>
  );

  // Additional timestamp for next scheduled run - shown on the LEFT side
  const additionalTimestamps = (
    <div className="flex items-center space-x-1 text-blue-100 text-sm">
      <Clock className="h-4 w-4" />
      <span>Next Scheduled Auto Run: {getNextRunDisplay()}</span>
    </div>
  );

  return (
    <StandardHeader
      title="Data Sync"
      subtitle="Sync and transform data from third-party applications"
      loading={loading}
      lastUpdated={getLastUpdatedTime()}
      onRefresh={onSyncAll}
      refreshButtonText="Sync All"
      isRefreshing={isSyncing}
      customControls={customControls}
      additionalTimestamps={additionalTimestamps}
    />
  );
};